import React from "react";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";

const GoogleTagsProvider = ({ children }) => {
  // const { user } = useUserMe();
  // const sendDataToGTM = useGTMDispatch();
  // const location = useLocation();

  // useEffect(() => {
  //   sendDataToGTM({ event: "pageview", value: location });
  // }, [sendDataToGTM, location]);

  const gtmParams = {
    id: "GTM-MN37F67",
    dataLayer: {
      congress: window.location.hostname
    }
  };

  return <GTMProvider state={gtmParams}>{children}</GTMProvider>;
};

export default GoogleTagsProvider;
